import React from 'react';
import O_CapsuleCommentsPost from '../O_Organisms/O_CapsuleCommentsPost/O_CapsuleCommentsPost';
import O_CapsuleLayout from '../O_Organisms/O_CapsuleLayout/O_CapsuleLayout';
import { MockPost } from '@/mocks/contentMocks';
import { Capsule } from '@/services/capsulesApi';
import { CapsuleReaction } from './types';
import styles from './CapsuleReactionsView.module.css';

interface CapsuleCommentSidebarProps {
  isMobile: boolean;
  selectedComment: CapsuleReaction | null;
  isExpandedView: boolean;
  canExpandCommentPanel: boolean;
  rightPanelMaxHeight: number | null;
  capsuleMock: MockPost;
  localReactionsCount: number;
  isAuthenticated: boolean;
  canComment: boolean;
  commentDraft: string;
  onCommentDraftChange: (value: string) => void;
  onCommentSubmit: () => void;
  canReply: boolean;
  replyDraft: string;
  onReplyDraftChange: (value: string) => void;
  onReplySubmit: () => void;
  capsule: Capsule;
}

export default function CapsuleCommentSidebar({
  isMobile,
  selectedComment,
  isExpandedView,
  canExpandCommentPanel,
  rightPanelMaxHeight,
  capsuleMock,
  localReactionsCount,
  isAuthenticated,
  canComment,
  commentDraft,
  onCommentDraftChange,
  onCommentSubmit,
  canReply,
  replyDraft,
  onReplyDraftChange,
  onReplySubmit,
  capsule,
}: CapsuleCommentSidebarProps) {
  return (
    <div
      className={styles.right_content}
      style={{ display: isMobile ? 'none' : 'flex' }}
    >
      {selectedComment && !isExpandedView && canExpandCommentPanel ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            maxHeight: rightPanelMaxHeight
              ? `${rightPanelMaxHeight}px`
              : '100%',
            overflow: 'hidden',
          }}
        >
          <O_CapsuleCommentsPost
            capsule={capsuleMock}
            comment={selectedComment}
            commentCount={localReactionsCount}
            plantCount={0}
            isAuthenticated={isAuthenticated}
            canComment={canComment}
            commentDraft={commentDraft}
            onCommentDraftChange={onCommentDraftChange}
            onCommentSubmit={onCommentSubmit}
            canReply={canReply}
            replyDraft={replyDraft}
            onReplyDraftChange={onReplyDraftChange}
            onReplySubmit={onReplySubmit}
          />
        </div>
      ) : (
        <O_CapsuleLayout
          title={capsule.title || ''}
          commentCount={capsule.engagement.comments || 0}
          plantCount={0}
        />
      )}
    </div>
  );
}
